module.exports = __webpack_public_path__ + "static/img/WaterStabilitySketch@2x.d43bf5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/WaterStabilitySketch@2x.png
// module id = kWpx
// module chunks = 1